import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class SchoolScene extends MinigameScene {
    //Images
    private winImage !: Phaser.GameObjects.Image;
    private loseImage !: Phaser.GameObjects.Image;
    private boyImage !: Phaser.GameObjects.Image;
    private endAnimation !: object;
    private endImage !: Phaser.GameObjects.Image;

    //values
    private noteValues : object[] = [
        {x: 505, y: 189, path: CONST.SCHOOL.NOTE_3},
        {x: 594, y: 195, path: CONST.SCHOOL.NOTE_4},
        {x: 605, y: 355, path: CONST.SCHOOL.NOTE_17},
        {x: 693, y: 289, path: CONST.SCHOOL.NOTE_20},
        {x: 703, y: 369, path: CONST.SCHOOL.NOTE_27},
        {x: 540, y: 285, path: CONST.SCHOOL.NOTE_H2NO},
        {x: 695, y: 206, path: CONST.SCHOOL.NOTE_YES}
    ];

    private endPoints : object[] = [
        {x: 265, y: 276, note: CONST.SCHOOL.NOTE_3},
        {x: 316, y: 183, note: CONST.SCHOOL.NOTE_17},
        {x: 305, y: 343, note: CONST.SCHOOL.NOTE_20},
    ];

    private maxEndDistance = 54; //in pixels
    private animFPS = 60;

    //logic vars
    private animTimer = 0;
    private notes : Phaser.GameObjects.Image[] = [];
    private isAnimating = false;
       
    constructor(){
        super ({
            sceneName: CONST.SCENES.SCHOOL,
            duration: 7000,
            startScreenColor: 0xFDC379,
            startText: "STUDY!",
            startTextColor: 0x323232,
            endScreen: CONST.SCHOOL.END,
            nextScene: CONST.SCENES.PUBERTY,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 386, scale: 1.30},
                normalWithSkip: {x: 283, y: 386, scale: 1.30},
                skip: {x: 570, y: 386, scale: 1.30}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.notes = [];
        this.animTimer = 0;
        this.isAnimating = false;
    }

    _preload(){
    }

    _create(){
        this.add.image(456, 240, CONST.SCHOOL.BACKGROUND);
        this.boyImage = this.add.image(425,394, CONST.SCHOOL.BOY).setDepth(100);

        this.createNotes();

        this.endAnimation = this.cache.json.get(CONST.ANIMATIONS.SCHOOLEND);
    }

    private createNotes(){
        this.noteValues.forEach(noteValue => {
            this.notes.push(
                this.add.image(noteValue.x, 
                               noteValue.y,
                               noteValue.path)
                        .setDepth(50)
                        .setInteractive(this.input.makePixelPerfect(50)));
        });

        //Create notes draggable
        this.notes.forEach(note => {
            this.input.setDraggable(note);
        })

        this.input.on('dragstart', function (pointer, gameObject) {
            this.children.bringToTop(gameObject);
            this.children.bringToTop(this.boyImage);

            this.sound.play(CONST.AUDIO.GRAB, {detune: this.getDetune()});
        }, this);
    
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });

        this.input.on('dragend', function(pointer, gameObject, dropped){
            this.sound.play(CONST.AUDIO.GRAB, {detune: this.getDetune()});
        }, this);

    }

    _update(time: number, delta: number){
        if (this.isAnimating){
            this.animTimer += delta;
            this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimation);
        }
    }

    _timeout(){
        this.checkForWin();
    }

    private checkForWin(){
        var isSolved = true;
        this.endPoints.forEach(endPoint =>{

            for (var i = 0; i < this.notes.length; i++){
                var currentNote = this.notes[i];
                if (currentNote.texture.key === endPoint.note){
                    var distance = Phaser.Math.Distance.Between(currentNote.x, currentNote.y, endPoint.x, endPoint.y);
                    if (distance > this.maxEndDistance){
                        isSolved = false;
                    }
                }
            }
            
        });

        if (isSolved){
            this.triggerWin();
        } else {
            this.triggerLoss();
        }
    }

    _afterLoss(){
        this.notes.forEach(note => {note.setVisible(false)}) 
        this.boyImage.setVisible(false);

        if (!this.endImage) return;
        this.endImage.setVisible(false);

    }

    _afterWin(){
        if (!this.endImage) return;
        this.endImage.setVisible(false);
    }

    private triggerLoss(){
        this.loseGame(1500);
        this.endGameAnim(false);
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(1500);
        this.endGameAnim(true);
        this.children.bringToTop(this.endImage);
    }

    private endGameAnim(win: boolean){
        var imageKey = win ? CONST.SCHOOL.WINIMAGE : CONST.SCHOOL.LOSEIMAGE;
        this.endImage = this.add.image(0, 0, imageKey).setScale(0, 0).setDepth(900);
        this.animTimer = 0;
        this.isAnimating = true;
    }

    private positionImageOnAnimation(timer: number, image: Phaser.GameObjects.Image, animation: object, xOffset: number = 0, yOffset: number = 0, angleOffset: number = 0, scaleMultiplier: number = 1){
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length){
            frameIndex = animation.frames.length - 1;
        }

        var frame = animation.frames[frameIndex];

        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset)
            .setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier)
            .setAngle(parseFloat(frame.angle) + angleOffset);
    }

}